import React from 'react';
import logo from '../TBL Logo White.png';
import './ClassVersionSelection.css';

const ClassVersionSelection = ({ onVersionSelect, onBack }) => {
  const handleVersionSelect = (version) => {
    onVersionSelect(version);
  };

  return (
    <div className="class-version-selection">
      <div className="version-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Home
        </button>
        <img src={logo} className="version-logo" alt="TBL Logo" />
        <h1>Choose Your Class Version</h1>
        <p>Select the type of wine class you'll be participating in:</p>
      </div>

      <div className="version-options">
        <div className="version-card red-version" onClick={() => handleVersionSelect('red')}>
          <div className="version-icon">🍷</div>
          <h2>RED</h2>
          <p>Red Wine Blending Class</p>
        </div>
        
        <div className="version-card white-version" onClick={() => handleVersionSelect('white')}>
          <div className="version-icon">🥂</div>
          <h2>WHITE</h2>
          <p>White Wine Blending Class</p>
        </div>
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default ClassVersionSelection;
